import { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

interface PeriodContextType {
  startDate: string;
  endDate: string;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  setPeriod: (start: string, end: string, label?: string) => void;
  label: string;
}

const PeriodContext = createContext<PeriodContextType | undefined>(undefined);

export function PeriodProvider({ children }: { children: ReactNode }) {
  // Default: current month
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
    .toISOString()
    .split("T")[0];
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
    .toISOString()
    .split("T")[0];

  const [startDate, setStartDate] = useState(firstDay);
  const [endDate, setEndDate] = useState(lastDay);
  const [label, setLabel] = useState("Ce mois");

  const setPeriod = (start: string, end: string, customLabel?: string) => {
    setStartDate(start);
    setEndDate(end);
    setLabel(customLabel ?? "Personnalisé");
  };

  return (
    <PeriodContext.Provider
      value={{ startDate, endDate, setStartDate, setEndDate, setPeriod, label }}
    >
      {children}
    </PeriodContext.Provider>
  );
}

export function usePeriod() {
  const context = useContext(PeriodContext);
  if (!context)
    throw new Error("usePeriod must be used within PeriodProvider");
  return context;
}
